// extracted by mini-css-extract-plugin
export default {"language":"languageComponent_language__k+R5h","languageItem":"languageComponent_languageItem__kb56Y","languageItemActive":"languageComponent_languageItemActive__kX-Qv"};